import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-phone-qr',
  templateUrl: './phone-qr.component.html',
  styleUrls: ['./phone-qr.component.scss']
})
export class PhoneQrComponent {
  @Input() phone: string;
  popupVisible = false;

  get telUri(): string {
    return this.phone ? 'tel:' + this.phone : '';
  }

  showPopup(event: MouseEvent) {
    event.stopPropagation();
    this.popupVisible = true;
  }

  closePopup() {
    this.popupVisible = false;
  }
}
